import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsFilterListComponent } from './ts-filter-list.component';
import { TsButtonModule } from '../ts-button';
import { TsFilterListItemModule } from '../ts-filter-list-item';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [TsFilterListComponent],
  imports: [CommonModule, TsButtonModule, TsFilterListItemModule, MatIconModule],
  exports: [TsFilterListComponent],
})
export class TsFilterListModule {}
